import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const FacebookCir24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.facebookFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm1.285 5.75c-2.13 0-2.615 1.47-2.615 2.41v1.58H9.625v2.03h1.545v5.48h2.098v-5.48h1.782l.325-2.03h-2.107V9.28c0-.448.487-.552.715-.552h1.362v-1.97l-1.56-.008z"
      fillRule="evenodd"
    />
  </svg>
);

export default FacebookCir24;
